import { Component, effect, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TimelineFacade } from '@app/core/components/timeline/facades/timeline.facade';
import { TimelineModalComponent } from '@app/core/components/timeline/timeline-modal/timeline-modal.component';
import { EventStateEnum } from '@app/core/enums/event.enum';
import { DomainValuesSharedService } from '@app/core/services/domain-values.shared.service';
import { UserSharedService } from '@app/core/services/user-shared.service';
import { SharedLibModule } from '@app/core/shared-lib/shared-lib.module';
import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { tap } from 'rxjs';
import { AppointmentsListFacade, AppointmentsListState } from './appointments-list.facade';
import { AppointmentRow } from './interfaces/appointment-row.interface';
import { EventOutcomeModal } from '../../components/event-outcome-modal/event-outcome-modal';
import { AppointmentFilters } from './interfaces/appointment-filters.interface';

@Component({
  templateUrl: './appointments-list.component.html',
  standalone: true,
  selector: 'appointments-list',
  providers: [DialogService],
  imports: [SharedLibModule],
  styles: [
    `
      ::ng-deep .p-contextmenu {
        width: auto !important;
        min-width: 12.5rem !important;
        max-width: 20rem !important;
      }
      ::ng-deep .p-contextmenu .p-menuitem > .p-menuitem-content .p-menuitem-link {
        white-space: nowrap !important;
      }
    `,
  ],
})
export class AppointmentsListComponent implements OnInit {
  private facade = inject(AppointmentsListFacade);
  private domainValuesSharedService = inject(DomainValuesSharedService);
  private timelineFacade = inject(TimelineFacade);
  private dialogService = inject(DialogService);
  private router = inject(Router);
  @Input() initialForm: Partial<AppointmentFilters> = {};
  @Input() filterLess = false;

  private usersService = inject(UserSharedService);
  selected?: AppointmentRow;
  users: any[] = [];
  menuItems: MenuItem[] = [];
  eventTypeOptions$ = this.domainValuesSharedService.getEventsType();
  eventStatesOptions$ = this.domainValuesSharedService.getEventState();
  sourceOptions$ = this.domainValuesSharedService.getSourcesType();

  usersOptions$ = this.usersService.getAllAgentsAndBackofficeList();
  state!: AppointmentsListState;
  EventStateEnum = EventStateEnum;

  constructor() {
    this.state = this.facade.getState;
    effect(() => {
      this.state = this.facade.getState;
    });
  }
  ngOnInit(): void {
    if (this.initialForm && this.filterLess) {
      this.state.requestData.filters = this.initialForm
      this.search();
    }
  }

  onSelect(row: AppointmentRow) {
    if (!row) return;

    this.menuItems = [
      {
        label: 'Esito',
        icon: 'pi pi-fw pi-check-circle',
        command: () => {
          this.openEventResultModal();
        },
      },
    ];
    if (row.projectSaleId || row.projectPurchaseId) {
      this.menuItems.push({
        label: 'Apri timeline',
        icon: 'pi pi-fw pi-calendar',
        command: () => {
          this.openTimelineModal();
        },
      });
    }
    if (row.projectSaleId) {
      this.menuItems.push({
        label: 'Dettaglio lead vendita',
        icon: 'pi pi-fw pi-user',
        command: () => {
          this.router.navigate(['sales/working-unit/info'], { queryParams: { id: row.projectSaleId } });
        },
      });
    }
    if (row.projectPurchaseId) {
      this.menuItems.push({
        label: 'Dettaglio lead acquisto',
        icon: 'pi pi-fw pi-user',
        command: () => {
          this.router.navigate(['purchases/working-unit/info'], { queryParams: { id: row.projectPurchaseId } });
        },
      });
    }
  }

  openEventResultModal() {
    this.dialogService
      .open(EventOutcomeModal, {
        header: 'Esito',
        width: '50%',
        data: {
          eventId: this.selected?.id,
        },
      })
      .onClose.pipe(
        tap(() => {
          this.search();
        }),
      )
      .subscribe();
  }

  openTimelineModal() {
    if (!this.selected?.id) return;

    this.timelineFacade
      .getTimeline(this.selected?.projectSaleId || this.selected?.projectPurchaseId)
      .pipe(
        tap((res) => {
          this.dialogService.open(TimelineModalComponent, {
            header: 'Timeline',
            width: '50%',
            data: {
              projectId: this.selected?.projectSaleId || this.selected?.projectPurchaseId,
              items: res,
            },
          });
        }),
      )
      .subscribe();
  }

  onTabChange(event: EventStateEnum) {
    this.state.requestData.filters.tabStatus = event != null ? [event] : undefined;
    this.search();
  }

  search(fromTable = false) {
    if (!fromTable) this.state.requestData.skip = 0;
    this.facade.search();
  }

  downloadCsv() {
    this.facade.downloadCsv();
  }
}
